import { render, staticRenderFns } from "./Form-footer.vue?vue&type=template&id=4b19694b&scoped=true&"
import script from "./Form-footer.vue?vue&type=script&lang=js&"
export * from "./Form-footer.vue?vue&type=script&lang=js&"
import style0 from "./Form-footer.vue?vue&type=style&index=0&id=4b19694b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b19694b",
  null
  
)

export default component.exports